import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { batchEmployeeService } from '../services/apiServices';
import { queryKeys } from '../config/queryClient';
import { BatchEmployeesResponse } from '../types';

export const useBatchEmployees = (batchId: number | null) =>
  useQuery<BatchEmployeesResponse>({
    queryKey: queryKeys.birdBatchEmployees(batchId ?? 0),
    queryFn: () => batchEmployeeService.getForBatch(batchId ?? 0),
    enabled: !!batchId,
  });

export const useAssignEmployeesToBatch = (batchId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { employee_ids: number[]; assigned_at?: string }) =>
      batchEmployeeService.assign(batchId, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.birdBatchEmployees(batchId) });
    },
  });
};

export const useReleaseEmployeeFromBatch = (batchId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (employeeId: number) => batchEmployeeService.release(batchId, employeeId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.birdBatchEmployees(batchId) });
    },
  });
};
